import getLocal from '@/app/utils/getLocal';
import classNames from 'classnames';
import EfImg from 'elem/ui/ef-img';
import React from 'react';
import EfDialogYoutube from '../ef-dialog-youtube';
import './index.scss';

export interface EfMediaItemProps {
    /**
     * 标题
     */
    title: string;
    /**
     * source
     */
    source: string;
    /**
     * 图片
     */
    img: string;
}

interface EfMediaBannerProps {
    pc: string;
    pad?: string;
    h5?: string;
}

export interface EfMediaYoutubeProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * theme
     */
    theme?: 'black' | 'white';
    /**
     * 段落标题
     */
    title?: string;
    /**
     * banner图
     */
    banner?: EfMediaBannerProps;
    /**
     * 列表
     */
    items: EfMediaItemProps[];
}

/**
 * 维护: kalkin
 *
 * Meida中youtueb列表
 */
const EfMediaYoutube: React.FC<EfMediaYoutubeProps> = ({ items = [], title, banner, className, theme = 'white' }) => {
    const { locale = 'us' } = getLocal();
    const prefixCls = `ef-media-youtube`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const [show, setShow] = React.useState('');

    return (
        <div className={classes}>
            {title && <p className={`${prefixCls}-title`}>{title}</p>}
            {banner?.pc && <EfImg className={`${prefixCls}-banner`} pc={banner?.pc} pad={banner?.pad || ''} h5={banner?.h5} />}
            <ul className={`${prefixCls}-items`}>
                {items?.map((item: EfMediaItemProps, k: number) => (
                    <li className={`${prefixCls}-item`} key={k}>
                        <div className={`${prefixCls}-item-img`} onClick={() => setShow(item.source)}>
                            <EfImg pc={item.img} />
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM28.0661 20.8524C28.7021 20.4621 28.7021 19.538 28.0661 19.1477L18.1781 13.0801C17.5118 12.6712 16.6551 13.1507 16.6551 13.9324V26.0677C16.6551 26.8495 17.5118 27.3289 18.1781 26.92L28.0661 20.8524Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <p className={`${prefixCls}-item-title`}>{item.title}</p>
                    </li>
                ))}
            </ul>
            {show && <EfDialogYoutube open={show} callback={() => setShow('')} src={show} />}
        </div>
    );
};

export default EfMediaYoutube;
